export function CusipCell({ cusip }: { cusip: string }) {
  return (
    <div className="flex items-center gap-2">
      {cusip}
    </div>
  )
}